<template>
  <div
    class="card-tarja-tropa-ge-v2"
    :class="{
      'card-tarja-tropa-ge-v2--fullscreen': isFullScreen,
      'card-tarja-tropa-ge-v2--media': isVisualMedia,
      'card-tarja-tropa-ge-v2--media-with-text':
        isVisualMedia && item.dsc_texto_colaboracao,
    }"
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <div
      class="manchete-layout"
      :class="{ 'manchete-layout--media': isVisualMedia }"
    >
      <LayoutBackgroundHeader
        v-if="isVisualMedia"
        class="manchete-layout__background"
      />
      <LayoutBackground v-else class="manchete-layout__background" />
      <div class="manchete-layout__title" :style="{ fontSize: titleFontSize }">
        {{ headerText }}
      </div>
      <div
        v-if="item.url_midia_colaboracao && isVisualMedia"
        class="manchete-layout__media"
      >
        <img
          v-if="item.dsc_tipo_midia_colaboracao === 'image'"
          :src="item.url_midia_colaboracao"
          alt="Mídia da colaboração"
        />
        <video
          v-else
          autoplay
          muted
          playsinline
          :src="item.url_midia_colaboracao"
        ></video>
      </div>
      <audio
        v-else-if="item.url_midia_colaboracao && item.dsc_tipo_midia_colaboracao === 'audio'"
        class="manchete-layout__audio"
        controls
        controlslist="nodownload"
        autoplay
        :key="item.url_midia_colaboracao"
      >
        <source :src="item.url_midia_colaboracao" />
      </audio>
      <div v-else class="manchete-layout__text">
        {{ item.dsc_texto_colaboracao || '' }}
      </div>
    </div>
  </div>
</template>

<script>
import LayoutBackground from "@/assets/tarjas/tropa-ge/tarja-manchete-v2.svg";
import LayoutBackgroundHeader from "@/assets/tarjas/tropa-ge/tarja-manchete-v2-header.svg";

export default {
  name: "CardTarjaTropaGEV2",
  components: {
    LayoutBackground,
    LayoutBackgroundHeader,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    posicaoCard: {
      type: String,
      default: "esquerda",
    },
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flgExibirUf: Boolean,
  },
  computed: {
    isVisualMedia() {
      return ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao);
    },
    headerText() {
      if (this.flgExibirUf && this.item.dsc_uf_colaborador) {
        return `${this.item.dsc_nome_colaborador} - ${this.item.dsc_uf_colaborador}`;
      }
      return this.item.dsc_nome_colaborador || "";
    },
    titleFontSize() {
      const titleLength = this.headerText.trim().length;
      if (titleLength > 30) {
        return "clamp(0.75rem, 1.9vw, 28px)";
      }
      if (titleLength > 18) {
        return "clamp(0.85rem, 2.15vw, 31px)";
      }
      return "clamp(0.95rem, 3.05vw, 44px)";
    },
    cardStyle() {
      if (this.isFullScreen) {
        return {
          width: "100%",
          height: "100%",
        };
      }

      const positionStyles = {
        esquerda: {
          justifySelf: "start",
          marginLeft: "0",
        },
        centro: {
          justifySelf: "center",
        },
        direita: {
          justifySelf: "end",
          marginRight: "0",
        },
      };

      return positionStyles[this.posicaoCard] || positionStyles.esquerda;
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Termina";
  src: url("@/assets/tarjas/tropa-ge/fonts/Termina.otf") format("opentype");
  font-weight: 400;
}

@font-face {
  font-family: "Termina";
  src: url("@/assets/tarjas/tropa-ge/fonts/Termina_Bold.otf") format("opentype");
  font-weight: 700;
}

.card-tarja-tropa-ge-v2 {
  position: relative;
  width: min(100vw, 1440px);
  aspect-ratio: 12 / 5;
  overflow: hidden;
}
.card-tarja-tropa-ge-v2--media {
  overflow: visible;
}

.card-tarja-tropa-ge-v2--fullscreen {
  aspect-ratio: auto;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}

.card-tarja-tropa-ge-v2--fullscreen .manchete-layout {
  flex: none;
  width: min(100vw, 1440px);
  aspect-ratio: 12 / 5;
}

.manchete-layout {
  position: relative;
  width: 100%;
  height: 100%;
}

.manchete-layout__background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.manchete-layout__title {
  position: absolute;
  left: 8.5%;
  top: 30%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 53%;
  height: 14%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 1%;
  color: #fff;
  font-family: "Termina", sans-serif;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}
.manchete-layout__text,
.manchete-layout__media,
.manchete-layout__audio {
  position: absolute;
  left: 9.9%;
  top: 45%;
  width: 80.2%;
  height: 22%;
}

.manchete-layout__text {
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #095339;
  font-family: "Termina", sans-serif;
  font-size: clamp(1rem, 2.82vw, 40.64px);
  line-height: 1.2;
}

.manchete-layout__media {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: visible;
  padding: 0.5rem 1rem;
}

.manchete-layout__media img,
.manchete-layout__media video {
  width: auto;
  height: auto;
  max-width: 30vw;
  max-height: 70vh;
  object-fit: contain;
}

.card-tarja-tropa-ge-v2--media:not(.card-tarja-tropa-ge-v2--fullscreen) {
  aspect-ratio: auto;
  height: auto;
}

.card-tarja-tropa-ge-v2--fullscreen.card-tarja-tropa-ge-v2--media {
  overflow: visible;
}

.card-tarja-tropa-ge-v2--media .manchete-layout {
  height: auto;
  min-height: min(41.67vw, 600px);
  box-sizing: border-box;
  padding-top: min(17.8vw, 256px);
  padding-bottom: min(12.7vw, 183px);
}

.card-tarja-tropa-ge-v2--fullscreen.card-tarja-tropa-ge-v2--media
  .manchete-layout {
  aspect-ratio: auto;
}

.manchete-layout--media .manchete-layout__title {
  top: min(12.5vw, 180px);
  height: min(5.8vw, 84px);
}
.manchete-layout--media .manchete-layout__background {
  height: auto;
  aspect-ratio: 12 / 5;
}

.manchete-layout--media .manchete-layout__media {
  position: relative;
  inset: auto;
  width: 83.7%;
  height: auto;
  min-height: min(11.2vw, 161px);
  margin: 0 auto;
  box-sizing: border-box;
  background: #ffb000;
  border: 4px solid #ff8125;
}

.manchete-layout--media .manchete-layout__media img,
.manchete-layout--media .manchete-layout__media video {
  max-width: 30vw;
  max-height: 70vh;
}

.card-tarja-tropa-ge-v2--fullscreen.card-tarja-tropa-ge-v2--media
  .manchete-layout__media img,
.card-tarja-tropa-ge-v2--fullscreen.card-tarja-tropa-ge-v2--media
  .manchete-layout__media video {
  max-width: 100%;
  max-height: 600px;
}

.card-tarja-tropa-ge-v2--fullscreen.card-tarja-tropa-ge-v2--media-with-text
  .manchete-layout__media img,
.card-tarja-tropa-ge-v2--fullscreen.card-tarja-tropa-ge-v2--media-with-text
  .manchete-layout__media video {
  max-height: 300px;
}
.manchete-layout__audio {
  width: 76%;
  height: auto;
  margin: 3% 2%;
}
</style>
